  export   const geoApiOptions = {
	method: 'GET',
	headers: {
		
		'X-RapidAPI-Key': '3ab9eedeeemsh37ec609bf36b9b6p1b04b2jsnc001e82699f7',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = 'https://wft-geo-db.p.rapidapi.com/v1/geo'; 

export const WEATHER_API_URL = 'https://api.openweathermap.org/data/2.5';



export const WEATHER_API_KEY = "23854785f74132c1481a5c44d54f86b7";


